<template>
    <div>
        
    </div>
</template>
<script>
export default {
    name: 'FormGrupo',
    props: {
        value: {
        },
        oAtributos:{
            type:Object,
            default:()=>{}
        },
        bObligatorio:{
            type: Boolean,
            default: false,
        },
        sLabel:{
            type: String,
            default: "",
        },
        sModoCampo:{
            type: String,
            default: "1",
        },
    },
    data() {
        return {
            valor: this.value,
            sPlaceholderTemp:""
        }
    },
    watch: {
        valor(NewValor) {
            this.$emit('input', NewValor)
        },
        value(NewValor){
            this.valor = NewValor
        }
    },
    methods : {
    }
}
</script>
<style scoped>
.segundoEstiloTitulo{
  color: #0056D3;
  font-size: medium;
}
</style>